<div class="help-page__header help-page__header--sub-header">
  {{ 'help-page.help' | translate }}
</div>

<div class="help-page__content" [innerHTML]="empSpecificContents.instruction"></div>
